import { Navigate, Route, Routes } from 'react-router-dom';
import { DashboardScreen } from '@/screens/DashboardScreen';
import { ReturnsListScreen } from '@/screens/ReturnsListScreen';
import { ReturnDetailScreen } from '@/screens/ReturnDetailScreen';
import { ExchangesScreen } from '@/screens/ExchangesScreen';
import { RefundsScreen } from '@/screens/RefundsScreen';
import { QcQueueScreen } from '@/screens/QcQueueScreen';
import { ExceptionsScreen } from '@/screens/ExceptionsScreen';
import { AnalyticsScreen } from '@/screens/AnalyticsScreen';
import { BlocklistScreen } from '@/screens/BlocklistScreen';
import { AutopilotScreen } from '@/screens/AutopilotScreen';
import { SettingsScreen } from '@/screens/SettingsScreen';
import { ManualReturnScreen } from '@/screens/ManualReturnScreen';
import { paths, routePatterns } from './paths';

export function AppRouter() {
  return (
    <Routes>
      <Route path={paths.dashboard} element={<DashboardScreen />} />
      <Route path={paths.returns} element={<ReturnsListScreen />} />
      <Route path={routePatterns.returnDetail} element={<ReturnDetailScreen />} />
      <Route path={paths.exchanges} element={<ExchangesScreen />} />
      <Route path={paths.refunds} element={<RefundsScreen />} />
      <Route path={paths.qc} element={<QcQueueScreen />} />
      <Route path={paths.exceptions} element={<ExceptionsScreen />} />
      <Route path={paths.analytics} element={<AnalyticsScreen />} />
      <Route path={paths.blocklist} element={<BlocklistScreen />} />
      <Route path={paths.autopilot} element={<AutopilotScreen />} />
      <Route path={paths.settings} element={<SettingsScreen />} />
      <Route path={paths.manualReturn} element={<ManualReturnScreen />} />
      <Route path="*" element={<Navigate to={paths.dashboard} replace />} />
    </Routes>
  );
}
